/**
 * Public Google Calendar booking page for a Flots demo. Every "book a demo" button opens
 * it directly: the canonical URL answers 200 with no redirect, unlike the short
 * `calendar.app.google` link or the `/u/0/` variant (one or two 302 hops each).
 */
export const DEMO_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1ZdXmLSvE7fatfXIj6oYzKrE6vtQBTza5aXMNeggUMv95r98qUDzkRjZc70l2mI2oK44qGSTTD";
